const imsrVersion = {
  version: "v26.04.0",
  updateDate: "2026/04/02",
  expireDays: 14
};

export default imsrVersion;
